import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterBuisness",
   pure: false
})
export class SearchBuisnessPipe implements PipeTransform {
  transform(items: any[], args: any): any {
    if (!args) {
      return items;
    }
    return items.filter((item)=>{
     return  item.dispensary_name.toLowerCase().trim().includes(args.toLowerCase())
    })

  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/search-buisness.pipe.ts